module.exports = __webpack_public_path__ + "static/media/gallery-next.8595470d.svg";